import { IServicePackagePeriod } from '../../../repositories/billing-tariffs/entities/PublishTerms/ServicePackagePeriod';
import { EServiceType, IServicePackages } from '../../../types/reducers/publishTerms';
import { EPublicationType } from '../../../types/reducers/publishTerms/publicationType';
import { mapInternalServiceTypes, getServiceId } from '../../../utils/publishTerms';
import { getPackageId } from './getPackageId';

export function mapPackages(packages: IServicePackagePeriod[]): IServicePackages {
  return packages.reduce((acc, servicePackage) => {
    const { tariffIdentificator, incompatibleServices, type, price, marketingPrice, token } = servicePackage;

    const packageId = getPackageId(servicePackage);
    const services = mapInternalServiceTypes<EServiceType>(tariffIdentificator.serviceTypes);
    const serviceId = getServiceId(services);

    acc[packageId] = {
      ...servicePackage,
      incompatibleServices: incompatibleServices as unknown as Array<EServiceType>,
      type: type as string as EPublicationType,
      id: packageId,
      price,
      marketingPrice,
      serviceId,
      token: token || null,
    };

    return acc;
  }, {} as IServicePackages);
}
